import { Component, Input, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WorkspaceService } from 'projects/gtw-elements/src/app/workspace/workspace.service';
import { environment } from 'projects/gtw-elements/src/environments/environment';
import { DashboardComponent } from '../../models/DashboardComponent';
import { ExProjectReviewService } from './ex-project-review.service';

@Component({
    selector: 'ex-project-review',
    templateUrl: './ex-project-review.component.html',
    styleUrls: ['./ex-project-review.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExProjectReviewComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  dashboard_id = 'project_review';
  dashboard_title = 'Project Review';
  data_sheets = [];
  // dashboard: Dashboard;
  activeScreenLocal: any;
  screenDataCache: any;
  selectedFilter: any;
  tableIndex: number;
  mouseOverSearchBox: boolean = false;
  menuOpen: boolean;
  projectList: any[];
  selectedProject: any;
  transByStepData: any[] | null;
  transData: any[] | null;
  transactionStepParentTable: any = {
    options: {}
  };
  transactionDataParentTable: any = {
    options: {}
  };
  dtInstance = {};
  dtInstanceTransaction = {};
  projectListLoading: boolean = false;
  tableLoading: any;
  projectSearchTerm: string = '';

  @Input()
  options!: any;

  constructor(
    private workspaceService: WorkspaceService,
    private projectReviewService: ExProjectReviewService
  ) {
    // this.dashboard = dashboardFactory.createDashboardOld(dashboard_title, dashboard_id, data_sheets);
    this.activeScreenLocal =
      this.workspaceService.workspaceFactory.activeScreen;
    this.screenDataCache = this.activeScreenLocal.data ?? {};
    this.selectedFilter = this.activeScreenLocal.filters.filterParams;
    this.screenDataCache = this.activeScreenLocal.data ?? {};
    this.tableIndex = this.screenDataCache.tableIndex ?? 0;
    this.menuOpen = this.screenDataCache.menuOpen ?? true;
    this.projectList = this.screenDataCache.projectList ?? [];
    this.selectedProject = this.screenDataCache.selectedProject;
    this.transByStepData = this.screenDataCache.transByStepData ?? [];
    this.transData = this.screenDataCache.transData ?? [];
  }

  ngOnInit(): void {
    this.loadProjects();
  }

  loadProjects() {
    if (this.projectList.length > 0) return;
    this.projectListLoading = true;

    this.projectReviewService
      .getProjectsByTaxYear(
        this.activeScreenLocal.filters.filterParams.tax_year
      ).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response) => {
        this.screenDataCache.projectList = response.ProjectsByTaxyear;
        this.screenDataCache.projectList.forEach((project: any) => {
          if (project.project_name) {
            const words = project.project_name.split(' ');
            let initials = [];
            for (let i = 0; i < words.length && initials.length < 2; i++) {
              if (isNaN(words[i])) {
                initials.push(words[i]);
              }
            }
            // pick the first two letters as initials if there's only one word
            if (initials.length === 1) {
              project.label = initials[0].replace(/\d/g, '').substring(0, 2);
            } else {
              project.label =
                initials[0].replace(/\d/g, '')[0] +
                initials[1].replace(/\d/g, '')[0];
            }
          }
        });
        this.projectList = this.screenDataCache.projectList;
        this.workspaceService.setCache(
          this.activeScreenLocal,
          this.screenDataCache
        );
        this.projectListLoading = false;
      });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.screenDataCache.menuOpen = this.menuOpen;
    this.workspaceService.setCache(
      this.activeScreenLocal,
      this.screenDataCache
    );
  }

  selectProject(project: any) {
    if (this.tableLoading) return;
    this.selectedProject = this.screenDataCache.selectedProject = project;
    this.workspaceService.setCache(
      this.activeScreenLocal,
      this.screenDataCache
    );
    this.options.title =
      this.dashboard_title + ' > ' + this.selectedProject.project_name;
    this.projectList.forEach((project) => {
      project.selected = false;
    });
    project.selected = true;
    this.loadTableData();
  }
  projectFilter(project: any, searchTerm?: string) {
    if (searchTerm) {
      return project.project_name
        .toLowerCase()
        .includes(searchTerm.toLowerCase().trim());
    }
    return true;
  }

  selectTab(tabIndex: number) {
    if (this.tableLoading) return;
    this.tableIndex = this.screenDataCache.tableIndex = tabIndex;
    this.workspaceService.setCache(
      this.activeScreenLocal,
      this.screenDataCache
    );
    this.selectedProject && this.loadTableData();
  }

  loadTableData() {
    this.tableLoading = true;
    if (this.tableIndex === 0) {
      this.transData = null;
      this.projectReviewService
        .getProjectSteps(
          this.selectedProject.project_id,
          this.activeScreenLocal.filters.filterParams
        ).pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response: any) => {
          this.transByStepData = this.screenDataCache.transByStepData =
            response.projectSteps;
          this.screenDataCache.hasTableData = true;
          this.workspaceService.setCache(
            this.activeScreenLocal,
            this.screenDataCache
          );
          this.dataLoaded();
          this.tableLoading = false;
        });
    } else if (this.tableIndex === 1) {
      this.transByStepData = null;
      this.projectReviewService
        .getTransactionData(
          this.selectedProject.project_id,
          this.activeScreenLocal.filters.filterParams
        ).pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response: any) => {
          this.transData = this.screenDataCache.transData =
            response.transactionData;
          this.screenDataCache.hasTableData = true;
          this.workspaceService.setCache(
            this.activeScreenLocal,
            this.screenDataCache
          );
          this.dataLoaded();
          this.tableLoading = false;
        });
    }
  }

  dataLoaded() {
    this.tableInit(this.transByStepData, this.transData);
  }
  tableInit(transByStepData: any[] | null, transData: any[] | null) {
    const transactionStepTableColConf = [
        {
            className: 'details-control'
        },
        {title: 'Step Number', data: 'step_label', width: 100, className: 'data-column'},
        {title: 'Step Name', data: 'step_name', className: 'data-column'},
        {title: 'Step Description', data: 'step_description', className: 'data-column'}
    ];
    const transactionDataTableColConf = [
        {title: 'Leid/CDR No/Rep Pd', data: 'entity_details', width: 70, className: 'data-column'},
        {title: 'Entity Name', data: 'le_name', width: 200, className: 'data-column'},
        {title: 'BSLA', data: 'me_code', width: 40, className: 'data-column text-center'},
        {title: 'Source', data: 'source_system_flag', width: 40, className: 'data-column text-center'},
        {title: 'Adj. Desc', data: 'adj_desc', width: 200, className: 'data-column'},
        {title: 'Usr. Desc', data: 'user_desc', width: 200, className: 'data-column'},
        {title: 'Curr.', data: 'curr', width: 30, className: 'data-column text-center'},
        {title: 'FG', data: 'consol_group_key', width: 10, className: 'data-column text-center'},
        {
            title: 'Amount - Incr/ (Decr)', data: 'amount', width: 50, className: 'data-column'
        },
        {
            title: 'Docs', data: 'doc_key', width: 20, className: 'data-column',
        },
        {
            title: 'DST',
            data: 'statement_name',
            width: 300,
            className: 'data-column text-link'
        }
    ];
    const transactionChildDataTableOptions = {
        columns: transactionDataTableColConf,
        isAjax: true,
        ajax: {
            url: `${environment.custom_api_url}/projectReview/getTransactionDataForProjectStep?project_id={project_id}&project_step_id={project_step_id}&tax_year=${this.selectedFilter.tax_year}&scenario=${this.selectedFilter.scenario}&filingKey=${this.selectedFilter.filing_key}&parent_me_string=${this.selectedFilter.parent_me_string}`,
            dataProp: 'transactionData'
        }
    };
    this.transactionStepParentTable.options = {
        data: transByStepData,
        extraOptions: {
            componentSettings: {
                groupColumnsBy: 'step_label',
                // childDataProp: 'transactionDataList',
                childTableOptions: transactionChildDataTableOptions,
                showChildRows: true,
                tableOptions: {
                    columns: transactionStepTableColConf,
                },
            }
        }
    }

    this.transactionDataParentTable.options = {
        data: transData,
        extraOptions: {
            componentSettings: {
                tableOptions: {
                    columns:transactionDataTableColConf
                }
            }
        },
    }

  }
}
